export const TiposIdentificacion = [
    {
        id: "NI",
        name: "NIT",
        symbol: "N"
    },
    {
        id: "CC",
        name: "CÉDULA",
        symbol: "C"
    },
    {
        id: "CE",
        name: "CÉDULA DE EXTRANJERÍA",
        symbol: "E"
    },
    {
        id: "PA",
        name: "PASAPORTE",
        symbol: "P"
    },
    {
        id: "RC",
        name: "REGISTRO CIVIL",
        symbol: "I"
    },
    {
        id: "TI",
        name: "TARJETA IDENTIDAD",
        symbol: "T"
    },
    {
        id: "CD",
        name: "CARNÉ DIPLOMÁTICO",
        symbol: "D"
    },
    {
        id: "M",
        name: "REGISTRO",
        symbol: "M"
    },
    {
        id: "PE",
        name: "PERMISO ESPECIAL",
        symbol: "Z"
    },
    {
        id: "PT",
        name: "PERMISO POR PROTECCIÓN TEMPORAL",
        symbol: "X"
    }
];

export const obtenerTipoIdentificacion = (symbol: string) =>
    TiposIdentificacion.find(element => element.symbol === symbol);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/modelo/TiposIdentificacion.ts